// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"9d41f6db","453":"80d6f396"}[chunkId] + ".chunk.js";
};